enum EventName {
  PageView = "PageView",
  PageLeave = "PageLeave",
  ElementView = "ElementView",
  ElementClick = "ElementClick",
  ElementSelect = "ElementSelect",
}

enum EventAction {
  View = "View",
  Leave = "Leave",
  Click = "Click",
  Select = "Select",
}

enum ObjectType {
  Page = "Page",
  Element = "Element",
}

type PageObject = {
  type: ObjectType.Page;
  id: string;
  name: string;
  path: string;
};

type ElementObject = {
  type: ObjectType.Element;
  id: string;
  name: string;
};

enum NavigationType {
  Navigate = "navigate",
  Reload = "reload",
  BackForward = "back-forward",
  Unknown = "unknown",
}

type CustomProperties = Record<string, unknown>;

type SharedProperties = {
  $ignore_sent_at: boolean;
};

type BaseEvent = {
  name: EventName;
  action: EventAction;
  navigationType: NavigationType;
  timestamp: string;
  customProperties?: CustomProperties;
};

type EnhancedEvent = BaseEvent & SharedProperties;

export {
  type CustomProperties,
  type PageObject,
  type ElementObject,
  type BaseEvent,
  type EnhancedEvent,
  ObjectType,
  NavigationType,
  EventName,
  EventAction,
};
